export default $ => {
    $('.eTooltip').each(function () {
        
        const toggle = $(this);
        
        toggle.mouseenter(function() {
            const content = toggle.find('.eTooltip__Text');
            
            const offset = toggle.offset();

            const h = toggle.height();
            const w = toggle.outerWidth(true);
            const cw = content.outerWidth(true);

            const winWidth = $(window).width();
            const scrollLeft = $(document).scrollLeft();
            const scrollTop = $(document).scrollTop();
            const position = {
                left: offset.left + w/2 - scrollLeft - cw/2,
                top: offset.top + h - scrollTop,
            };

            if (position.left + cw/2 > winWidth) {
                position.left -= (position.left + cw/2 - winWidth);
            }

            content.css(position);
        });
    });
};



// WEBPACK FOOTER //
// ./assets/js/component/tooltip.js